import { Color } from '@diritto/common/style/color';
import { Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface SettingItemProps {
  children?: ReactNode;
  title: string;
}

export const SettingSection = ({ children, title }: SettingItemProps) => (
  <div>
    <StyledTitle>{title}</StyledTitle>
    {children}
  </div>
);

const StyledTitle = styled.p`
  margin-top: 16px;
  margin-bottom: 8px;
  ${Typography.XXSmall};
  color: ${Color.Gray700};
`;
